'use strict';

// set this directive on an element to point to a "master" element
// this element is valid if its content is equal to the master's content
// but only if the master's content is already valid

angular.module('um.commonDirectives').directive('valueEqualTo', function() {
    return {
        require : 'ngModel',
        scope: {
            valueEqualTo: "="
        },
        link : function($scope, $attr, $elem, ngModel) {
            ngModel.$validators.equalTo = function(value) {
                return value === $scope.valueEqualTo;
            };

            $scope.$watch("valueEqualTo", function() {
                ngModel.$validate();
            });
        }
    }
});

//angular.module('um').directive('valueEqualTo', ['$timeout', function ($timeout) {
//    return {
//        require: ['ngModel', '^form'],
//        link: function ($scope, element, attrs, ctrls) {
//            var ngModelCtrl = ctrls[0];
//            var formCtrl = ctrls[1];
//            var ngMasterCtrl = formCtrl[attrs.valueEqualTo];
//
//            ngModelCtrl.$dirty = false;
//            // this element is valid, if the master is invalid (don't show this error until the master contains a valid value)
//            // this element is valid as long as the master is unchanged. This implies "valid-until-touched" on the master. We do not show an error before the user has had a chance to enter something
//            // TODO: check if the master really has the "valid-until-touched" directive on it (otherwise $touched will never be set)
//            // if the master is valid and the user has touched him, this element must be equal to his value
//            $timeout(function () {
//                ngModelCtrl.$parsers.unshift(function(viewValue) {
//                    ngModelCtrl.$setValidity('equalTo', ngMasterCtrl.$invalid || !ngMasterCtrl.$touched || viewValue === ngMasterCtrl.$viewValue);
//                    return viewValue;  // always update the model. Returning undefined would not update the model
//                });
//                // trigger this elements validation if the viewValue or the touched state of the master changed
//                // don't hook into master's parsers. Wait until all validation on the master is done. We need his 'valid' state
//                // don't watch the master's model value. The model might not be updated when the parsers switch to 'invalid'
//                $scope.$watch(function () {
//                    return ngMasterCtrl.$viewValue + ngMasterCtrl.$touched;
//                }, function () {
//                    ngModelCtrl.$setViewValue(ngModelCtrl.$viewValue);  // trigger validation
//                });
//            }, 0);
//        }
//    };
//}]);
